<div class="thanks__flex">
  <div class="thanks__logo">
    <div class="sg-logo-img__wrapper">
      <img proLogoImg alt="logo" class="logo-intro" />
    </div>
  </div>
  <div class="thanks__container">
    <div class="thanks__row">
      <div class="thanks__column thanks__column--center">
        <div class="thanks__icon">
          <mat-icon class="icon-check-circle">check_circle</mat-icon>
        </div>
        <h1 class="thanks__title" *ngIf="!isOperationNOTE && !isOperationDWN">
          {{ 'signaturit_pro.thanks.finishpro_thanks_status_signed' | translate:_transParam }}
        </h1>
        <h1 class="thanks__title" *ngIf="isOperationDWN">
          {{ 'signaturit_pro.thanks.finishpro_thanks_status_signed_dwn' | translate:_transParam }}
        </h1>
        <h1 class="thanks__title" *ngIf="isOperationNOTE">
          {{ 'signaturit_pro.thanks.finishpro_thanks_status_signed_note' | translate:_transParam }}
        </h1>
        <p class="thanks__bulk" *ngIf="showMassiveSection && !isPublic">
          {{ 'signaturit_pro.thanks.finishpro_thanks_pending_docs' | translate:_transParam }}
          <a class="thanks__bulk-link" href="#">
            {{ 'signaturit_pro.thanks.finishpro_thanks_review_docs' | translate:_transParam }}
          </a>
        </p>
        <p class="thanks__exit">
          <a class="thanks__exit-button" href="" (click)="exitProcess()">
            {{ 'signaturit_pro.general.go_dashboard' | translate:_transParam }}
          </a>
        </p>
        <signaturit-button *ngIf="urlCallback"
          text="{{ 'signaturit_pro.thanks.finishpro_thanks_callback' | translate:_transParam }}" type="primary"
          size="sm" (click)="redirectCallback(urlCallback)"></signaturit-button>
        <div class="thanks__box">
          <div class="thanks__box__content">
            <div class="thanks__box__content__register">
              <h1 class="thanks__box__content__register__title">
                {{ 'signaturit_pro.thanks.finishpro_thanks_experience' | translate:_transParam }}
              </h1>
              <p class="thanks__box__content__register__body">
                {{ 'signaturit_pro.thanks.finishpro_thanks_sign_up' | translate:_transParam }}
              </p>
              <div class="thanks__box__content__register__button">
                <div class="thanks__box__content__register__button__wrapper">
                </div>
              </div>
            </div>
            <div class="thanks__box__content__social-login">
              <div class="thanks__box__content__social-login__title-decorator"></div>
              <h1 class="thanks__box__content__social-login__title">
                {{ 'signaturit_pro.thanks.finishpro_thanks_sign_up_other_account' | translate:_transParam }}
              </h1>
              <div class="thanks__box__content__social-login__title-decorator"></div>
              <div class="thanks__box__content__social-login__buttons">
                <div class="thanks__box__content__social-login__buttons__left">
                  <a href="#"
                    class="thanks__box__content__social-login__buttons__icon thanks__box__content__social-login__buttons__icon--twitter"></a>
                </div>
                <div class="thanks__box__content__social-login__buttons__right">
                  <a href="#" target="_blank"
                    class="thanks__box__content__social-login__buttons__icon thanks__box__content__social-login__buttons__icon--linkedin"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="thanks__box__contact">
          <p *ngIf="!customText && isVisibleCustomText" class="thanks__box__contact__info" [innerHTML]="
              'signaturit_pro.thanks.finishpro_thanks_contact' | translate
                    : {
                      email: email,
                      class: 'thanks__box__contact__info-link'
                    }
            "></p>
          <p *ngIf="customText && isVisibleCustomText" class="thanks__box__contact__info" [innerHTML]="customText"></p>
        </div>
      </div>
    </div>
  </div>
</div>
